import React from "react";
import { Segment, Header, Icon } from "semantic-ui-react";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
  Cell,
} from "recharts";
import "./AcademicPerformance.scss";

export function AcademicPerformance(props) {
  const { courses } = props;

  return (
    <Segment className="dashboard-segment">
      <Header as="h3" dividing>
        <Icon name="chart bar" />
        Rendimiento Académico
      </Header>
      {courses?.length > 0 ? (
        <div style={{ width: "100%", height: 280 }}>
          <ResponsiveContainer>
            <BarChart
              data={courses}
              margin={{ top: 20, right: 30, left: 0, bottom: 60 }}
            >
              <CartesianGrid
                strokeDasharray="3 3"
                stroke="var(--border-grey-light)"
              />
              <XAxis
                dataKey="subjectName"
                tick={{ fontSize: 11, fill: "var(--text-color-70)" }}
                interval={0}
                angle={-35}
                textAnchor="end"
                height={80}
              />
              <YAxis domain={[0, 20]} tick={{ fill: "var(--text-color-70)" }} />
              <Tooltip
                contentStyle={{
                  backgroundColor: "var(--card-bg)",
                  border: "1px solid var(--border-grey-light)",
                  borderRadius: "8px",
                }}
              />
              <Bar dataKey="averageGrade" name="Promedio" radius={[4, 4, 0, 0]}>
                {courses.map((entry, index) => (
                  <Cell
                    key={`cell-${index}`}
                    fill={
                      entry.averageGrade >= 16
                        ? "#10b981"
                        : entry.averageGrade >= 13
                        ? "#3b82f6"
                        : entry.averageGrade >= 11
                        ? "#f59e0b"
                        : "#ef4444"
                    }
                  />
                ))}
              </Bar>
            </BarChart>
          </ResponsiveContainer>
        </div>
      ) : (
        <div className="empty-state">
          <Icon name="chart bar outline" />
          <p>No hay datos académicos disponibles.</p>
        </div>
      )}
    </Segment>
  );
}
